/**
 * ChipGroup
 * Multi-select chip toggle group used for all checkbox-style questions.
 * options: array of { value, label } or array of strings
 * value: array of selected values
 * onChange: (newValues) => void
 */
export default function ChipGroup({ options, value = [], onChange, error }) {
    const toggle = (opt) => {
        const val = typeof opt === 'string' ? opt : opt.value;
        const next = value.includes(val)
            ? value.filter(v => v !== val)
            : [...value, val];
        onChange(next);
    };

    return (
        <div>
            <div className="flex flex-wrap gap-2 mt-1">
                {options.map((opt) => {
                    const val     = typeof opt === 'string' ? opt : opt.value;
                    const label   = typeof opt === 'string' ? opt : opt.label;
                    const active  = value.includes(val);
                    return (
                        <button
                            key={val}
                            type="button"
                            onClick={() => toggle(opt)}
                            aria-pressed={active}
                            className="px-3 py-1.5 rounded-pill text-xs font-medium border transition-all duration-150 active:scale-95"
                            style={{
                                background  : active ? '#EBF8F3' : 'white',
                                borderColor : active ? '#2ECC8E' : '#d8eaf5',
                                color       : active ? '#0a5c40' : '#4a6882'
                            }}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
            {error && <p className="text-xs mt-1.5" style={{ color: '#E24B4A' }}>{error}</p>}
        </div>
    );
}
